<template>
  <v-container fluid class="whitelist">
    <v-row class="flex-grow-0">
      <h3>{{ $t('app_drawer.whitelist') }}</h3>
      <v-spacer></v-spacer>
      <v-btn color="primary"
             depressed
             tile
             class="mr-4"
             @click="refresh"
             key="refresh-client">
        <v-icon>fas fa-sync-alt</v-icon>
      </v-btn>
      <v-btn color="primary"
             depressed
             tile
             class="mr-4"
             @click="importWhiteList"
             key="import-whitelist">
        <v-icon>mdi-file-document-plus-outline</v-icon>
      </v-btn>
      <v-btn color="primary"
             depressed
             tile
             class="mr-4"
             @click="addWhiteList"
             key="add-whitelist">
        <v-icon>fas fa-plus</v-icon>
      </v-btn>
    </v-row>
    <v-row class="flex-grow-1">
      <v-col>
        <AdfsWhiteListList full-height
                           :refresh-trigger.sync="refreshTrigger"></AdfsWhiteListList>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {ref} from "@vue/composition-api";
import AdfsWhiteListList from "@/components/whitelist/AdfsWhiteListList";
import AddAdfsWhiteListDialog from "@/components/whitelist/AddAdfsWhiteListDialog";
import ImportAdfsWhiteListDialog from "@/components/whitelist/ImportAdfsWhiteListDialog";

export default {
  name: 'AdfsWhiteList',
  components: {AdfsWhiteListList},
  setup(props, {root}) {
    const refreshTrigger = ref(false);
    const refresh = function () {
      refreshTrigger.value = !refreshTrigger.value;
    };

    const importWhiteList = async function () {
      const needRefresh = await root.$dialog.showAndWait(
          ImportAdfsWhiteListDialog,
          {
            showClose: false,
            persistent: true,
            scrollable: true,
            width: '80vw',
          }
      );

      if (needRefresh === true) {
        refresh();
      }
    }

    const addWhiteList = async function () {
      const needRefresh = await root.$dialog.showAndWait(
          AddAdfsWhiteListDialog,
          {
            showClose: false,
            persistent: true,
            scrollable: true,
          }
      );

      if (needRefresh === true) {
        refresh();
      }
    }

    return {
      refreshTrigger,
      refresh,

      importWhiteList,
      addWhiteList,
    }
  }
}
</script>

<style lang="less">
.whitelist {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>
